const React = require("react");
const T = React.PropTypes;
const moment = require("moment");

require("./LegacySurvey.less");

const navigator = require("~/navigator.js");
const legacyAuditLoadDispatchers = require("~/events/auditLoad/legacyAuditLoadDispatchers.js");
const SurveyType = require("~/types/Survey.js").PropType;
const AuditTypes = require("~/config.js").AuditTypes;

const MajorMessage = require("../MajorMessage/MajorMessage.jsx");
const MajorLoading = require("../MajorLoading/MajorLoading.jsx");
const SurveyLoadError = require("../SurveyLoadError/SurveyLoadError.jsx");

const LegacySurvey = React.createClass({
    propTypes: {
        Survey: SurveyType.isRequired
    },
    componentWillMount() {
        if (!this.props.Survey.Completed) {
            legacyAuditLoadDispatchers.LoadAudit(
                this.props.Survey.Type,
                this.props.Survey.FacilityNumber,
                this.props.Survey.GUID);
        }
    },
    componentWillReceiveProps(newProps) {
        if (!newProps.Survey.LoadError
            && !newProps.Survey.IsLoading) {
            if (this.props.Survey.GUID !== newProps.Survey.GUID) {
                legacyAuditLoadDispatchers.LoadAudit(
                    newProps.Survey.Type,
                    newProps.Survey.FacilityNumber,
                    newProps.Survey.GUID);
            }
        }
    },
    render() {
        let message = this.GetMessage();

        if (message) {
            return (<MajorMessage>
                {message}
            </MajorMessage>);
        }
        
        const survey = this.props.Survey;

        const auditType = AuditTypes[this.props.Survey.Type];

        const typeName = (auditType ? auditType.FriendlyName : "") || "Type unknown";

        const facilityName = ("000" + survey.FacilityNumber).slice(-4);

        const completed = moment(survey.CompletedOn).format("M-D-YYYY");

        const mostRecent = moment(survey.MostRecentAudit).format("M-D-YYYY");

        const pct = survey.MaxScore === 0
            ? 0
            : (survey.Score / survey.MaxScore * 100).toFixed(0);

        const score = (<span>{survey.Score}/{survey.MaxScore} - {pct}%</span>)

        const files = this.GetFiles();
        const fileRow = files ? this.MakeRow("Files", files) : null;

        return (<main className="cs-LegacySurvey">
            <h3>
                <span>Store&nbsp;{facilityName}</span>
                <span>&nbsp;-&nbsp;{typeName}</span>
                <br />
                <span className="cs-LegacySurvey__header-period">
                    {survey.AuditPeriod}
                </span>
            </h3>
            {this.MakeRow("Confirmation Code", survey.ConfirmationCode)}
            {this.MakeRow("Score", score)}
            {this.MakeRow("Location", "Store " + facilityName)}
            {this.MakeRow("Completed On", completed)}
            {this.MakeRow("Auditor", survey.CompletedBy)}
            {this.MakeRow("Most Recent Audit", mostRecent)}
            {fileRow}
            <footer className="cs-LegacySurvey__remark">
                This audit was imported from the old system.
                The details are only available via the PDF export
                and attachments above.
            </footer>
        </main>);
    },
    GetMessage() {
        if (this.props.Survey.LoadError) {
            return (<SurveyLoadError Error={this.props.Survey.LoadError } />);
        }

        if (this.props.Survey.IsLoading) {
            return (<MajorLoading />);
        }

        return null;
    },
    MakeRow(label, children) {
        return (<div className="cs-LegacySurvey__row">
            <div className="cs-LegacySurvey__row__term">
                {label}
            </div>
            <div className="cs-LegacySurvey__row__content">
                {children}
            </div>
        </div>);
    },
    GetFiles() {
        if (this.props.Survey.Attachments && this.props.Survey.Attachments.length) {
            const attachments = this.props.Survey.Attachments.map((a, i) => {
                const url = navigator.GetLink.ToAttachment(a);

                var name = a.Name.match(/\.pdf$/)
                    ? "Audit Export"
                    : "Attachments";
                
                return (<li key={i}>
                    <a className="cs-LegacySurvey__link" href={url}>
                        {name}
                    </a>
                </li>);
            });

            return (<ul className="cs-LegacySurvey__attachment-list">
                {attachments}
            </ul>);
        }

        return null;
    }
});

module.exports = LegacySurvey;


// WEBPACK FOOTER //
// ./src/components/LegacySurvey/LegacySurvey.jsx